import { Check } from "lucide-react";

export interface ImageResult {
  url: string;
  title: string;
  thumbnail: string;
  photographer?: string;
  photographerUrl?: string;
}

interface ImageGridProps {
  images: ImageResult[];
  selectedImageUrl?: string | null;
  onImageSelect?: (image: ImageResult | null) => void;
  onAskAboutPhoto?: () => void;
}

const ImageGrid = ({ images, selectedImageUrl, onImageSelect }: ImageGridProps) => {
  if (!images.length) return null;

  const handleImageTap = (img: ImageResult) => {
    if (!onImageSelect) return;
    if (selectedImageUrl === img.url) {
      onImageSelect(null);
    } else {
      onImageSelect(img);
    }
  };

  return (
    <div className="mt-3">
      <p className="text-xs font-body text-kin-slate mb-2">📸 Photo inspiration</p>
      <div className="grid grid-cols-2 gap-2">
        {images.map((img, i) => {
          const isSelected = selectedImageUrl === img.url;
          return (
            <div key={i} className="relative group">
              <button
                onClick={() => handleImageTap(img)}
                className={`w-full overflow-hidden rounded-[16px] aspect-[4/3] bg-muted focus:outline-none transition-all duration-200 ${
                  isSelected
                    ? "ring-[3px] ring-kin-periwinkle ring-offset-2 ring-offset-card"
                    : "focus:ring-2 focus:ring-kin-periwinkle"
                }`}
              >
                <img
                  src={img.thumbnail}
                  alt={img.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-200 hover:scale-105"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = "none"; }}
                />
              </button>
              {isSelected && (
                <div className="absolute top-2 right-2 bg-kin-periwinkle rounded-full p-0.5">
                  <Check size={14} className="text-primary-foreground" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageGrid;
